module.exports = __webpack_public_path__ + "static/media/logo_transparent.fe3fd906.png";